import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const sendContactSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address"),
  subject: z.string().min(1, "Subject is required"),
  message: z.string().min(10, "Message must be at least 10 characters"),
  recaptchaToken: z.string().optional(),
});

export class SendContactDto extends createZodDto(sendContactSchema) {}
